function handleButtonClick(videoUrl) {
    if (!videoUrl || videoUrl === "blank") return;
    let isYouTube = videoUrl.includes("youtube.com") || videoUrl.includes("youtu.be");
    if (isYouTube) {
        openYouTubePopup(videoUrl);
    } else {
        // window.location.href = videoUrl;
        window.open(videoUrl, "_blank");
    }
}

function openYouTubePopup(videoUrl) {
    document.body.style.overflow = "hidden";
    let videoId = "";
    if (videoUrl.includes("youtube.com/watch?v=")) {
        videoId = videoUrl.split("v=")[1]?.split("&")[0];
    } else if (videoUrl.includes("youtu.be/")) {
        videoId = videoUrl.split("youtu.be/")[1]?.split("?")[0];
    }

    if (videoId) {
        let popupHtml = `
            <div id="youtube-popup-overlay" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.7); display: flex; align-items: center; justify-content: center; z-index: 1000;" onclick="closeYouTubePopup(event)">
                <div id="youtube-popup-content" style="position: relative; width: 80%; max-width: 800px; background: #fff; padding: 20px; border-radius: 10px;">
                    <span onclick="closeYouTubePopup()" style="position: absolute; top: -8px; right: 5px; cursor: pointer; font-size: 20px;"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <g clip-path="url(#clip0_208_6450)">
                    <path d="M13 1L1 13M1 1L13 13" stroke="#3A2018" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </g>
                    <defs>
                    <clipPath id="clip0_208_6450">
                    <rect width="14" height="14" fill="white"/>
                    </clipPath>
                    </defs>
                    </svg></span>
                    <iframe width="100%" height="400px" src="https://www.youtube.com/embed/${videoId}?autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
                </div>
            </div>
        `;
        document.body.insertAdjacentHTML('beforeend', popupHtml);
    }
}
function closeYouTubePopup(event) {
    if (!event || event.target.id === "youtube-popup-overlay") {
        let popup = document.getElementById("youtube-popup-overlay");
        if (popup) popup.remove();
        document.body.style.overflow = "";
    }
}

